import { render, staticRenderFns } from "./Slide1.vue?vue&type=template&id=44d2a442&scoped=true&"
import script from "./Slide1.vue?vue&type=script&lang=ts&"
export * from "./Slide1.vue?vue&type=script&lang=ts&"
import style0 from "./Slide1.vue?vue&type=style&index=0&id=44d2a442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d2a442",
  null
  
)

export default component.exports